import * as React from 'react'

function SvgIconBluetooth(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 32 32" width="1em" height="1em" {...props}>
      <g id="bluetooth" aria-labelledby="t-bluetooth d-bluetooth">
        <title id="t-bluetooth">{'Bluetooth'}</title>
        <desc id="d-bluetooth">{'Bluetooth symbol'}</desc>
        <path d="M15 32V19.2l-5.6 5.7L7.5 23l6.9-6.9-7-7 1.9-1.9 5.7 5.7V0l9.6 9.6-6.4 6.4 6.399 6.4L15 32zm2.7-12.6v6l3-3-3-3zm0-12.8v5.9l3-3-3-2.9z" />
      </g>
    </svg>
  )
}

export default SvgIconBluetooth
